<template>
    <div>
        <el-form label-width="120px" label-position="top">
            <el-form-item :label="$t('Coordinates')">
                <addresscoordinatesfield
                    v-model="coordinates"
                    :address.sync="geocodedAddress"
                    :editable="editable"
                />
            </el-form-item>
        </el-form>

        <addressform v-model="address" :address="geocodedAddress" :editable="editable" />
    </div>
</template>

<script>
import eventBus from '@app/src/lib/helpers/eventbus';
import FormQuestion from '@/data/FormQuestion';
import Visit from '@/data/Visit';
import addressform from '../addressform.vue';
import addresscoordinatesfield from '../addresscoordinatesfield.vue';

export default {
    name: 'visitlocationaddress',
    components: {
        addressform,
        addresscoordinatesfield,
    },
    props: {
        question: {
            type: FormQuestion,
            required: true,
        },
        visit: {
            type: Visit,
            required: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            address: {},
            geocodedAddress: null,
        };
    },
    created() {
        this.parse();
    },
    mounted() {
        eventBus.$on('saveForm', this.saveForm);
        eventBus.$on('formdetailloaded', this.parse);
    },
    beforeDestroy() {
        eventBus.$off('saveForm', this.saveForm);
        eventBus.$off('formdetailloaded', this.parse);
    },
    computed: {
        returnValue: {
            get() {
                return this.question.data.return_value;
            },
            set(value) {
                this.question.data.return_value = value;
            },
        },
        coordinates: {
            get() {
                return {
                    lat: this.address.latitude,
                    lng: this.address.longitude,
                };
            },
            set({ lat, lng }) {
                this.address.latitude = lat;
                this.address.longitude = lng;
            },
        },
    },
    methods: {
        parse() {
            let address;

            if (this.returnValue) {
                address = JSON.parse(this.returnValue || '{}');
            } else {
                const {
                    latitude,
                    longitude,
                    street1,
                    street2,
                    country,
                    city,
                    district,
                    postal_code,
                    address_text,
                } = this.visit.address;

                address = {
                    latitude,
                    longitude,
                    street1,
                    street2,
                    country,
                    city,
                    district,
                    postal_code,
                    address_text,
                };
            }

            this.address = address;
        },
        saveForm() {
            this.returnValue = JSON.stringify(this.address);
        },
    },
};
</script>

<style lang="scss"></style>
